import {
  useRoute,
  useRouter,
  useCurrentLanguage,
  useState,
  computed,
  ref,
  onBeforeUnmount
} from "#imports";
import {
  languages
} from "#nuxt-language-negotiation/config";
import { pageLanguageLinks } from "#nuxt-language-negotiation/routes";
export function useLanguageLinks() {
  const stateLinks = useState(
    "pageLanguageLinks",
    () => {
      return {};
    }
  );
  const currentLanguage = useCurrentLanguage();
  const route = useRoute();
  const router = useRouter();
  function getRouteName(route2) {
    return route2.meta.originalName || route2.name?.toString();
  }
  const currentRouteName = ref(getRouteName(route));
  const currentRoutePath = ref(route.path);
  const removeGuard = router.afterEach((to) => {
    currentRouteName.value = getRouteName(to);
    currentRoutePath.value = to.path;
  });
  onBeforeUnmount(removeGuard);
  const mapping = computed(
    () => {
      if (stateLinks.value[currentRoutePath.value]) {
        return stateLinks.value[currentRoutePath.value] || null;
      } else if (currentRouteName.value) {
        return pageLanguageLinks[currentRouteName.value] || null;
      }
      return null;
    }
  );
  return computed(() => {
    return languages.map((language) => {
      const code = language.code;
      const to = mapping.value?.[code];
      if (to) {
        return {
          ...language,
          enabled: true,
          to,
          active: code === currentLanguage.value
        };
      }
      return {
        ...language,
        enabled: false,
        to: void 0,
        active: code === currentLanguage.value
      };
    });
  });
}
